export const asset = {
  variants: {
    button: {
      states: {
        '&:hover': {
          cursor: 'pointer',
        },
      },
    },
  },
};
